import type { ComponentProps } from 'react';

import { Waypoint } from 'react-waypoint';

import { Separator } from '@change-corgi/design-system/components/content';
import { Box, Container } from '@change-corgi/design-system/layout';

import { SuggestedPetitionsLazy } from 'src/app/shared/components/suggestedPetitionsLazy';

import { usePageFooter } from './hooks/usePageFooter';

export function PageFooter(props: ComponentProps<typeof Box>) {
	const {
		data: { petitionId },
		actions: { handleSuggestedPetitionsPosition },
	} = usePageFooter();

	return (
		<Box {...props}>
			<Container variant="small">
				<Separator role="presentation" my={24} />
			</Container>
			<Waypoint
				onPositionChange={({ currentPosition }) => handleSuggestedPetitionsPosition(currentPosition === 'below')}
			/>
			<SuggestedPetitionsLazy channel="dm_responses" sourceLocation="dm_responses" petitionSlugOrId={petitionId} />
		</Box>
	);
}
